import { render, staticRenderFns } from "./DashBoard2.vue?vue&type=template&id=7b20a1a0&scoped=true&"
import script from "./DashBoard2.vue?vue&type=script&lang=js&"
export * from "./DashBoard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20a1a0",
  null
  
)

export default component.exports